export default "__VITE_ASSET__Bl7WpHqk__"